import React, { useState } from "react";
import "./Curriculum.css";
import cintelli from "../../assets/cintellij.png";
import cgithub from "../../assets/cgithub.png";
import cjunit from "../../assets/cjunit.png"
import cjava from "../../assets/cjava.png"
import cbullettick from "../../assets/corangetick.png"
import { FaCheckCircle } from "react-icons/fa";
import curriculumprogramming from "../../assets/curriculumprogramming.png";
import curriculumdsa from "../../assets/curriculumdsa.png";
import curriculumfrontend from "../../assets/curriculumfrontend.png";
import curriculumbackend from "../../assets/curriculumbackend.png";
import curriculumgenai from "../../assets/curriculumgenai.jpeg";
import curriculumhdl from "../../assets/curriculumhdl.png";

const courseData = [
  {
    id: 1,
    name: "Programming",
    title: "Introduction to Programming",
    description: "This course introduces fundamental programming concepts using Python. Students will learn about variables, data types, control structures, functions, and basic object-oriented programming.",
    topics: [
      "Python Basics",
      "Control Structures",
      "Functions and Modules",
      "Object-Oriented Programming",
      "File Handling and Exceptions"
    ],
    image:curriculumprogramming,
    tools: [cintelli, cgithub, cjava]
  },
  {
    id: 2,
    name: "DSA",
    title: "Data Structures and Algorithms",
    description: "This course delves into essential data structures such as arrays, linked lists, stacks, queues, and trees, along with algorithms for searching, sorting, and optimizing. It emphasizes problem-solving techniques and algorithmic thinking.",
    topics: [
      "Algorithms Analysis and Bit Manipulation",
      "Arrays and Linked Lists",
      "Stacks and Queues",
      "Searching and Sorting",
      "Sets and Dictionaries"
    ],
    image:curriculumdsa,
    tools: [cintelli, cgithub, cjunit, cjava]
  },
  {
    id: 3,
    name: "Frontend",
    title: "Frontend Development",
    description: "Learn to create responsive and interactive user interfaces using modern frontend technologies. This course covers HTML, CSS, JavaScript, and popular frontend frameworks.",
    topics: [
      "HTML5 and CSS3",
      "JavaScript Fundamentals",
      "React.js",
      "State Management",
      "Responsive Web Design"
    ],
    image:curriculumfrontend,
    tools: [cgithub, cintelli]
  },
  {
    id: 4,
    name: "Backend",
    title: "Backend Development",
    description: "Explore server-side programming, database management, and API development. This course focuses on building robust and scalable backend systems.",
    topics: [
      "Node.js and Express.js",
      "RESTful API Design",
      "Database Management (SQL and NoSQL)",
      "Authentication and Authorization",
      "Server Deployment and Scaling"
    ],
    image:curriculumbackend,
    tools: [cgithub, cjava]
  },
  {
    id: 5,
    name: "GenAI",
    title: "Generative AI",
    description: "Dive into the world of generative AI, exploring techniques for creating AI models that can generate new content, from text to images and beyond.",
    topics: [
      "Introduction to Machine Learning",
      "Neural Networks and Deep Learning",
      "Generative Adversarial Networks (GANs)",
      "Natural Language Processing",
      "Ethics in AI"
    ],
    image:curriculumgenai,
    tools: [cintelli, cgithub]
  },
  {
    id: 6,
    name: "HLD",
    title: "High-Level Design",
    description: "Learn to design large-scale distributed systems. This course covers system architecture, scalability, reliability, and best practices in software design.",
    topics: [
      "System Design Fundamentals",
      "Scalability and Performance",
      "Microservices Architecture",
      "Data Storage and Caching",
      "Load Balancing and Fault Tolerance"
    ],
    image:curriculumhdl,
    tools: [cgithub]
  }
];

const Curriculum = () => {

  const [activeCourse, setActiveCourse] = useState(1);

  const handleCourseClick = (courseId) => {
    setActiveCourse(courseId);
  };

  const currentCourse = courseData.find(course => course.id === activeCourse);

  return (
    <div className="curriculum-container">
      <p className="curriculum-header">Full Stack Development Career Acceleration Program</p>
      <h1 className="curriculum-title">AI-Enhanced Full-Stack Development Advanced Curriculum</h1>
      
      <div className="curriculum-courses-navigation">
        {courseData.map(course => (
          <button 
            key={course.id}
            className={`curriculum-course-button ${activeCourse === course.id ? 'active' : ''}`}
            onClick={() => handleCourseClick(course.id)}
          >
            Module {course.id}<br/>{course.name}
          </button>
        ))}
      </div>
      
      <div className="curriculum-course-details">
        <h2 className="curriculum-course-title">{currentCourse.title}</h2>
        <p className="curriculum-course-description">{currentCourse.description}</p>
        <div className="curriculum-topic-image">
          <div className="curriculum-topics-covered">
            <h3>Topics Covered</h3>
            <ul className="curriculum-topics-list">
              {currentCourse.topics.map((topic, index) => (
              <li key={index} className="curriculum-topic-item">
                <FaCheckCircle className="curriculum-icon"/>
                <span>{topic}</span>
              </li>
            ))}
          </ul>
        </div>

         <div className="curriculum-course-image-container">
    <img src={currentCourse.image} alt={currentCourse.name} className="curriculum-course-image"/>
  </div>
        </div>
        
        
        {/* <div className="curriculum-tools-section">
          {currentCourse.tools.map((tool, index) => (
            <img key={index} src={tool} alt={`Tool ${index + 1}`} />
          ))}
        </div> */}
      </div>
      <div className="curriculum-downloadsyllabus-section">
        <button className="curriculum-download-syllabus-button">Download Syllabus</button>
      </div>
    </div>
  );
};

export default Curriculum;